// Static equipment catalogue for the BYOM ("bring your own manual") wizard.
// Extend by adding entries here — the UI renders whatever is in this file.
// Every manufacturer/model list also gets an "Other" option in the UI, which
// switches to free-text input.

export const OTHER_KEY = '__other__';

export const EQUIPMENT_CATEGORIES = [
  {
    key: 'main_engine',
    label: 'Main Engine',
    manufacturers: [
      { key: 'man', label: 'MAN B&W', models: ['ME-GI', 'ME-C', 'ME-B', 'MC-C'] },
      { key: 'wartsila', label: 'Wärtsilä', models: ['RT-flex', 'X-DF', 'W-X'] },
      { key: 'mitsubishi', label: 'Mitsubishi', models: ['UEC'] },
    ],
  },
  {
    key: 'aux_engine',
    label: 'Aux Engine',
    manufacturers: [
      { key: 'yanmar', label: 'Yanmar', models: ['EY', 'N21', 'N330'] },
      { key: 'daihatsu', label: 'Daihatsu', models: ['DC', 'DK'] },
      { key: 'man', label: 'MAN', models: ['L16/24', 'L21/31', 'L23/30H', 'L27/38'] },
      { key: 'wartsila', label: 'Wärtsilä', models: ['W20', 'W26', 'W32'] },
    ],
  },
  {
    key: 'purifier',
    label: 'Purifier',
    manufacturers: [
      { key: 'alfa-laval', label: 'Alfa Laval', models: ['P 615', 'P 626', 'S 938', 'S 949'] },
      { key: 'mitsubishi', label: 'Mitsubishi Kakoki', models: ['SJ'] },
      { key: 'westfalia', label: 'GEA Westfalia', models: ['OSD', 'OSE'] },
    ],
  },
  {
    key: 'boiler',
    label: 'Boiler',
    manufacturers: [
      { key: 'aalborg', label: 'Alfa Laval Aalborg', models: ['OS', 'OL', 'Mission'] },
      { key: 'miura', label: 'Miura', models: ['VWS', 'GK'] },
    ],
  },
  {
    key: 'compressor',
    label: 'Compressor',
    manufacturers: [
      { key: 'tanabe', label: 'Tanabe', models: ['H-63', 'H-64', 'H-73'] },
      { key: 'sperre', label: 'Sperre', models: ['HL2', 'HV2'] },
      { key: 'hatlapa', label: 'Hatlapa', models: ['W-type', 'L-type'] },
    ],
  },
  {
    key: 'pump',
    label: 'Pump',
    manufacturers: [
      { key: 'shinko', label: 'Shinko', models: ['SVS', 'RVP', 'CVS'] },
      { key: 'iron', label: 'IRON Pump', models: ['ON', 'CN'] },
      { key: 'framo', label: 'Framo', models: ['SD100', 'SD125', 'SD150'] },
    ],
  },
  {
    key: 'other',
    label: 'Other',
    manufacturers: [], // free text only
  },
];

// "MAN B&W" -> "man-bw", "P 615" -> "p-615". Path-safe, lowercase.
export function slugify(text) {
  return String(text || '')
    .toLowerCase()
    .normalize('NFKD') // "Wärtsilä" -> "wartsila"
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);
}

// -> "main_engine/man/me-gi" or null when a part is missing/empty.
export function buildEquipmentPath(categoryKey, manufacturer, model) {
  const category = EQUIPMENT_CATEGORIES.find(c => c.key === categoryKey);
  if (!category) return null;
  const mfrSlug = slugify(manufacturer);
  const modelSlug = slugify(model);
  if (!mfrSlug || !modelSlug) return null;
  return `${category.key}/${mfrSlug}/${modelSlug}`;
}
